var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.5V13A1.25 1.25 0 0113 14.25H3A1.25 1.25 0 011.75 13V9.5a.75.75 0 011.5 0v3.25h9.5V9.5a.75.75 0 111.5 0zm-6.78.53a.751.751 0 001.062 0l2.5-2.5a.751.751 0 00-1.063-1.062L8.75 7.688V2.5a.75.75 0 00-1.5 0v5.188L6.03 6.468a.751.751 0 10-1.062 1.063L7.47 10.03z",
    fill: "#292875"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default "/_next/static/images/4c7bbb45ec3c41dfe99fe909a38c537f.svg";
export { ForwardRef as ReactComponent };